
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'StageOfChildrenAge',
components: {
XTable
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Pedi/StageOfChildrenAge.vue